import app from '../firebase';
import { useState } from 'react';
import { getFirestore, setDoc, doc, query, where, getDocs, collection } from 'firebase/firestore';
import { getAuth, createUserWithEmailAndPassword } from 'firebase/auth';

export default function Register() {

    const [email, setEmail]         = useState();
    const [password, setPassword]   = useState();
    const [name, setName]           = useState();

    const register = async () => {
        
        if (!name || !email || !password) {
            return alert('Please fill out all necessary information!');
        }
        
        // check email existence
        await getDocs(query(collection(getFirestore(app), 'users'), where('email', '==', email)))
            
            .then(result => {
                if (result.size > 0) {
                    return alert('Email already in use!');
                }
            });

        await createUserWithEmailAndPassword(getAuth(app), email, password)

            .then(async result => {

                let newUser = {
                    name,
                    email,
                    phone: '',
                    address: {
                        house:          '',
                        street:         '',
                        barangay:       '',
                        municipality:   '',
                        province:       '',
                        landmark:       '',
                    },
                    seller: false
                };
                
                await setDoc(doc(getFirestore(app), 'users', result.user.uid), newUser);
                localStorage.setItem('userId', result.user.uid);
                window.location.replace('/');
            })
            
            .catch(() => {
                alert('Invalid credentials, please use other email or password!');
            });
	}

    return (
        <>
            <div className="bg-light d-flex align-items-center justify-content-center p-4">
                <div className="container w-25">
                    <br />
                    <h1 className="text-success">Welcome Home</h1>
                    <input type="text"      className="form-control form-control-lg mb-2" placeholder="Full Name"       onChange={data => setName(data.target.value)} />
                    <input type="email"     className="form-control form-control-lg mb-2" placeholder="Email Address"   onChange={data => setEmail(data.target.value)} />
                    <input type="password"  className="form-control form-control-lg mb-2" placeholder="Password"        onChange={data => setPassword(data.target.value)} />

                    <button className="btn btn-lg btn-success mb-2 w-100" onClick={register}><i className="bi-person-fill me-2"></i>Register</button>
                    <button className="btn btn-lg btn-dark w-100" onClick={() => window.location.replace('/login')}>Login</button>

                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                </div>
            </div>
        </>
    );
}